import { useContext } from "react";
import styled from "styled-components";
import { usePostCardContext } from ".";
import { CenterPanelContext } from "../..";
import { hideScrollBar } from "../../../../../../commonStyles";
import { FlexColumn } from "../../../../../Common/Styles";
import { Content } from "../3-Content";

export const ExpandedPostCardContentView = () => {
  const { showOriginalPost, originalPostId } = useContext(CenterPanelContext);
  const { isWithinRepostModal, isWithinRepostPost, postId } =
    usePostCardContext();
  const isWithinRepost = isWithinRepostModal || isWithinRepostPost;
  const isOriginalPostShown = showOriginalPost && originalPostId === postId;

  return (
    <Container
      className="post-card"
      $gapInPx={0}
      $hideBoxShadow={isOriginalPostShown || isWithinRepost}
    >
      <Content />
    </Container>
  );
};

const Container = styled(FlexColumn)<{
  $hideBoxShadow: boolean;
}>(
  ({ theme, $hideBoxShadow }) => `
  background-color: ${theme.Color.elevation.surface["surface-primary"].value};
  border-radius: ${theme.radius["radius-xs"].value}rem;
  box-shadow: ${$hideBoxShadow ? "none" : theme.boxShadows["box-shadow-m"]};
  overflow: scroll;
  ${hideScrollBar}
`
);
